(() => {
  function matchesNiche(product, key) {
    const definitions = {
      'vintage-retro':['Vintage & Retro',['ns_retro'],['vintage','retro','synthwave','mid century']],
      'graffiti-pop-art':['Graffiti & Pop Art',['ns_street'],['graffiti','pop art','street art','hypebeast']],
      'gothic-dark-academia':['Gothic & Dark Academia',['ns_gothic'],['gothic','dark academia']],
      'cultural-folk-art':['Cultural & Folk Art',['ns_cultural'],['cultural','folk art','folk print','woodblock','sumi e']],
      'watercolour':['Watercolour',[],['watercolour','watercolor']],
      'typography':['Typography',[],['typography','typographic','quote','slogan']],
      'illustration-sketch':['Illustration & Sketch',[],['illustration','illustrated','sketch','drawing','hand drawn','ink','pencil','charcoal','sumi e','woodcut','line art']],
      'photography-collage':['Photography & Collage',[],['photography','photographic','photo art','photo print','collage','photomontage']],
      'vintage-traditional':['Vintage & Traditional',[],['antique','traditional','classic','engraving','etching','heritage','victorian','renaissance','medieval']],
      'living-room':['Living Room',[],['living room','lounge']],
      'bedroom':['Bedroom',[],['bedroom']],
      'kitchen':['Kitchen',[],['kitchen']],
      'bathroom':['Bathroom',[],['bathroom']],
      'hallway':['Hallway',[],['hallway','entryway','entrance hall']],
      'home-office':['Home Office',[],['home office','office decor','study decor']],
      'childrens-room':["Children's Room",[],['children','kids','nursery','baby']],
      'gift:nature-lovers':['For nature lovers',['gift_nature_lovers','ns_nature'],['nature lover','landscape','wildlife','botanical','floral','coastal','woodland','mountain']],
      'gift:travellers':['For travellers',['gift_travellers','ns_travel'],['travel','cityscape','destination','yorkshire','paris','tokyo','london']],
      'gift:gamers':['For gamers',['gift_gamers','ns_gaming'],['gaming','gamer','arcade','video game']],
      'gift:history-lovers':['For history lovers',['gift_history_lovers','ns_ancient','ns_military','ns_american'],['history lover','ancient','historical','military','mythology','roman empire','medieval','washington']]
    };
    if (key === 'children-s-room') key = 'childrens-room';
    if (key === 'history-lovers') key = 'gift:history-lovers';
    if (key === 'gift:all' || key === 'gift:most-loved') return true;
    const explicitAssignment = window.YPArtworkCategories?.assignment?.(product, key);
    if (explicitAssignment !== null && explicitAssignment !== undefined) return explicitAssignment;
    const definition = definitions[key];
    if (!definition) return null;
    const normal = value => String(value).toLowerCase().replaceAll('&',' and ').replace(/[^\p{L}\p{N}]+/gu,' ').trim();
    const tags = (product.tags || []).map(normal);
    if (tags.includes(normal(definition[0]))) return true;
    if ((product.tags || []).includes('drive-import-20261020')) {
      return definition[1].filter(tag=>tag.startsWith('gift_')).some(tag=>tags.includes(normal(tag)));
    }
    if (definition[1].some(tag=>tags.includes(normal(tag)))) return true;
    const text = normal((product.title || '')+' '+(product.tags || []).join(' '));
    return definition[2].some(term=>(' '+text+' ').includes(' '+normal(term)+' '));
  }

  const root = document.querySelector('[data-category-browser]');
  if (!root) return;
  let artworkMap;
  let loading = true;
  let generation = 0;
  window.YPPlainArtwork.load(root.dataset.artworkMapUrl).then(map => {
    artworkMap = map;
    window.YPPlainArtwork.render(grid, map);
  }).catch(() => {
    artworkMap = {};
    window.YPPlainArtwork.render(grid, artworkMap);
  });
  const url = new URL(location.href);
  if (!['best-selling','created-descending'].includes(url.searchParams.get('sort_by'))) {
    url.searchParams.set('sort_by', 'best-selling');
    history.replaceState(null, '', url.href);
  }
  const categories = {
    'flowers-botanicals': ['Flowers & Botanicals', ['flower','floral','botanical']],
    'animals-pets': ['Animals & Pets', ['animal','pet','wildlife']],
    'modern-figurative-art': ['Modern & Figurative Art', ['modern','figurative']],
    'fantasy-celestial': ['Fantasy & Celestial', ['fantasy','celestial']],
    'military-aviation': ['Military & Aviation', ['military','aviation']],
    'remembrance-art': ['Remembrance Art', ['remembrance']],
    'kids-nursery': ['Kids & Nursery', ['kids','nursery','children']],
    'quotes-pop-culture': ['Quotes & Pop Culture', ['quotes','pop culture']],
    'christmas-seasonal': ['Christmas & Seasonal', ['christmas','winter','seasonal']]
  };
  const browseGroups = {
    'graffiti-pop-art': ['Graffiti & Pop Art', ['graffiti','pop art','street art']],
    'gothic-dark-academia': ['Gothic & Dark Academia', ['gothic','dark academia']],
    'cultural-folk-art': ['Cultural & Folk Art', ['cultural','folk art']],
    "colour-black": ["Black Art Prints",["black cat","dark","gothic","black glitter","black background"],["10568150417674"]],
    "colour-black-white": ["Black & White Art Prints",["black white","black and white","monochrome","sumi-e","ink illustration"],["10568093401354"]],
    "colour-blue": ["Blue Art Prints",["blue","cobalt","navy"],["10568104149258"]],
    "colour-green": ["Green Art Prints",["green","emerald","sage"],["10568147042570"]],
    "colour-pink": ["Pink Art Prints",["pink","blush"],["10568147403018"]],
    "colour-red": ["Red Art Prints",["red","crimson","burgundy"],[]],
    "colour-orange": ["Orange Art Prints",["orange","terracotta"],["10568155463946"]],
    "colour-purple": ["Purple Art Prints",["purple","violet","lavender","wisteria"],["10568151269642"]],
    "colour-neutrals": ["Neutral Art Prints",["neutral","beige","cream","sand","taupe"],["10568155431178"]],
    'vintage-retro': ['Vintage & Retro', ['vintage','retro','synthwave','mid-century','mid century']],
    'illustration-sketch': ['Illustration & Sketch', ['illustration','illustrated','sketch','drawing','hand drawn','hand-drawn','ink','pencil','charcoal','sumi-e','woodcut','line art']],
    'photography-collage': ['Photography & Collage', ['photography','photographic','photo art','photo print','collage','photomontage']],
    'vintage-traditional': ['Vintage & Traditional', ['antique','traditional','classic','engraving','etching','heritage','victorian','renaissance','medieval']],
    'watercolour': ['Watercolour', ['watercolour','watercolor']],
    'typography': ['Typography', ['typography','typographic','quote','slogan']],
    'living-room': ['Living Room', ['living room','lounge']],
    'bedroom': ['Bedroom', ['bedroom']],
    'bathroom': ['Bathroom', ['bathroom']],
    'history-lovers': ['For history lovers', ['history lovers','ancient','historical','military','mythology','roman empire','medieval','washington']],
    'kitchen': ['Kitchen', ['kitchen']],
    'hallway': ['Hallway', ['hallway','entryway','entrance hall']],
    'home-office': ['Home Office', ['home office','office decor','study decor']],
    'childrens-room': ["Children's Room", ['children','kids','nursery','baby']]
  };
  const artworkCategory = window.YPArtworkCategories.definition(url.searchParams.get('category') || location.pathname.split('/').filter(Boolean).pop());
  const category = categories[url.searchParams.get('category')] || browseGroups[url.searchParams.get('browse')];
  const giftTitles = {'nature-lovers':'For nature lovers','travellers':'For travellers','gamers':'For gamers','history-lovers':'For history lovers','most-loved':'Most-loved gifts','all':'All gift ideas'};
  const giftTitle = giftTitles[url.searchParams.get('gift')];
  const nicheKey = giftTitle ? 'gift:'+url.searchParams.get('gift') : url.searchParams.get('browse');
  const nicheFilter = nicheKey && matchesNiche({title:'',tags:[]},nicheKey) !== null;
  const catalogUrl = nicheFilter && nicheKey !== 'gift:most-loved' ? (window.Shopify?.routes?.root || '/')+'collections/all-artwork' : root.dataset.collectionUrl;
  const grid = root.querySelector('[data-category-grid]');
  const status = root.querySelector('[data-filter-status]');
  const count = root.querySelector('[data-category-count]');
  const more = root.querySelector('[data-category-more]');
  const clear = root.querySelector('[data-clear-filters]');
  const empty = root.querySelector('[data-category-empty]');
  const pageSize = Number(root.dataset.pageSize) || 24;
  let visible = pageSize * Math.max(1, Number(url.searchParams.get('page')) || 1);
  let products = [];
  const groups = ['categories','location','style','room','recipient'];
  const selected = Object.fromEntries(groups.map(group => [group, new Set(url.searchParams.getAll(group))]));
  const active = root.querySelector('[data-active-filters]');
  if (category) {
    root.querySelector('[data-category-title]').textContent = category[0];
    document.title = category[0] + ' — YorkshirePrintsGB';
    grid.hidden = true;
  }
  if (giftTitle) {
    grid.hidden = true;
    root.querySelector('[data-category-title]').textContent = giftTitle;
    document.title = giftTitle + ' — YorkshirePrintsGB';
  }
  const mobileViewport = matchMedia('(max-width:749px)');
  const closeMobileFilters = () => {
    if (mobileViewport.matches) root.querySelector('.yp-category__sidebar').open = false;
  };
  closeMobileFilters();
  mobileViewport.addEventListener('change', closeMobileFilters);
  function syncURL() {
    const next = new URL(location.href);
    groups.forEach(group => {
      next.searchParams.delete(group);
      selected[group].forEach(value => next.searchParams.append(group, value));
    });
    ['size','format','print_format'].forEach(key => next.searchParams.delete(key));
    next.searchParams.delete('page');
    history.replaceState(null, '', next.href);
  }
  function filtered() {
    return products.filter(product => groups.every(group => !selected[group].size ||
      [...selected[group]].some(value => product.filters[group].includes(value))));
  }
  function draw() {
    const matches = filtered();
    grid.innerHTML = matches.slice(0, visible).map(product => '<li>' + product.html + '</li>').join('');
    if (artworkCategory) grid.querySelectorAll('a[href]').forEach(link => {
      const target = new URL(link.getAttribute('href'), location.origin);
      if (target.origin === location.origin && target.pathname.includes('/products/')) {
        target.searchParams.set('recommendation_category', artworkCategory[0]);
        link.setAttribute('href', target.pathname + target.search);
      }
    });
    if (artworkMap) window.YPPlainArtwork.render(grid, artworkMap);
    grid.hidden = loading && matches.length === 0;
    count.textContent = matches.length + (matches.length === 1 ? ' print' : ' prints') + (loading ? '+' : '');
    more.hidden = visible >= matches.length;
    empty.hidden = loading || matches.length !== 0;
    clear.hidden = !groups.some(group => selected[group].size);
    active.replaceChildren();
    groups.forEach(group => selected[group].forEach(value => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'yp-category__active-pill';
      button.textContent = value + ' ×';
      button.setAttribute('aria-label', 'Remove ' + value + ' filter');
      button.addEventListener('click', () => {
        selected[group].delete(value);
        root.querySelectorAll('[data-filter-group="' + group + '"] input').forEach(input => {if (input.value === value) input.checked = false;});
        visible = pageSize; syncURL(); draw();
      });
      active.append(button);
    }));
    active.hidden = !active.childElementCount;
    status.textContent = loading ? 'Loading more matching prints…' : '';
    root.dataset.catalogState = loading ? 'loading' : 'ready';
    root.querySelector('[data-native-pagination]').hidden = true;
    document.dispatchEvent(new CustomEvent('category:render'));
  }
  function makeChoices(group, choices) {
    const fieldset = root.querySelector('[data-filter-group="' + group + '"]');
    if (!fieldset) return;
    fieldset.replaceChildren(fieldset.querySelector('legend'));
    choices.forEach(([value, total]) => {
      const label = document.createElement('label');
      const input = document.createElement('input');
      input.type = 'checkbox'; input.value = value; input.checked = selected[group].has(value);
      input.addEventListener('change', () => {
        if (input.checked) selected[group].add(value); else selected[group].delete(value);
        visible = pageSize; syncURL(); draw();
      });
      const labelText = document.createElement('span');
      labelText.textContent = value;
      const choiceCount = document.createElement('small');
      choiceCount.textContent = String(total);
      label.append(input, labelText, choiceCount);
      fieldset.append(label);
    });
    fieldset.disabled = false;
    fieldset.closest('details').hidden = choices.length < 2 && !selected[group].size;
    if (group === 'location') {
      const term = root.querySelector('[data-location-search]')?.value.trim().toLowerCase() || '';
      fieldset.querySelectorAll('label').forEach(label => {
        label.hidden = !label.querySelector('span').textContent.toLowerCase().includes(term);
      });
    }
  }
  root.querySelectorAll('input[name="sort_by"]').forEach(input => input.addEventListener('change', () => {
    url.searchParams.set('sort_by', input.value);
    const next = new URL(location.href);
    next.searchParams.set('sort_by', input.value);
    next.searchParams.delete('page');
    history.replaceState(null, '', next.href);
    visible = pageSize;
    startLoad();
  }));
  root.querySelector('[data-location-search]')?.addEventListener('input', event => {
    const term = event.target.value.trim().toLowerCase();
    root.querySelectorAll('[data-filter-group="location"] label').forEach(label => {
      label.hidden = !label.querySelector('span').textContent.toLowerCase().includes(term);
    });
  });
  clear.addEventListener('click', () => {
    groups.forEach(group => selected[group].clear());
    root.querySelectorAll('[data-filter-group] input').forEach(input => {input.checked = false;});
    const locationSearch = root.querySelector('[data-location-search]');
    if (locationSearch) {
      locationSearch.value = '';
      root.querySelectorAll('[data-filter-group="location"] label').forEach(label => {label.hidden = false;});
    }
    visible = pageSize; syncURL(); draw();
  });
  more.addEventListener('click', () => {visible += pageSize; draw();});
  function prepare(rows) {
    products = rows;
    if (nicheFilter) {
      products = products.filter(product => matchesNiche(product,nicheKey));
    } else if (artworkCategory) {
      products = products.filter(product => window.YPArtworkCategories.matches(product, artworkCategory[0]));
    } else if (category) {
      products = products.filter(product => {
        if (url.searchParams.get('browse') === 'history-lovers' && product.tags.includes('drive-import-20261020')) {
          return product.tags.includes('gift_history_lovers');
        }
        const text = (product.title + (url.searchParams.has('browse') ? ' ' + product.tags.join(' ').replaceAll('_',' ') : '')).toLowerCase();
        if (url.searchParams.get('browse')?.startsWith('colour-')) {
          return category[2].includes(String(product.id)) || category[1].some(term => new RegExp('(?:^|[^a-z])' + term + '(?:$|[^a-z])').test(text));
        }
        return category[1].some(term => text.includes(term));
      });
    }
    products.forEach(product => {
      product.filters = Object.fromEntries(groups.map(group => {
        const value = product.facets?.[group];
        return [group, Array.isArray(value) ? value : value ? [value] : []];
      }));
    });
  }
  function makeAllChoices() {
    groups.forEach(group => {
      const tally = new Map();
      products.forEach(product => product.filters[group].forEach(value => tally.set(value, (tally.get(value) || 0) + 1)));
      selected[group].forEach(value => {if (!tally.has(value)) tally.set(value, 0);});
      const choices = [...tally].sort((a,b) => b[1] - a[1] || a[0].localeCompare(b[0]));
      makeChoices(group,choices);
    });
  }
  async function load() {
    const ticket = ++generation;
    loading = true;
    root.dataset.catalogState = 'loading';
    status.textContent = 'Loading matching prints…';
    try {
      const data = await window.YPCatalogData.load(catalogUrl, url.searchParams.get('sort_by'), partial => {
        if (ticket !== generation) return;
        root.dataset.catalogSource = partial.source;
        prepare(partial.products);
        draw();
      });
      if (ticket !== generation) return;
      root.dataset.catalogSource = data.source;
      prepare(data.products);
      loading = false;
      makeAllChoices();
      draw();
    } catch (error) {
      if (ticket !== generation) return;
      loading = false;
      root.dataset.catalogState = 'error';
      const shown = grid.querySelector('.yp-category-card');
      status.textContent = shown ? 'Some prints could not load. Refresh to try again.' : 'Filters could not load. Please refresh to try again.';
      if (!shown && (category || giftTitle)) {
        count.textContent = '';
        grid.innerHTML = '';
        empty.hidden = false;
        empty.textContent = 'This category could not load. Please refresh to try again.';
        root.querySelector('[data-native-pagination]').hidden = true;
      }
    }
  }
  function startLoad() { load(); }
  startLoad();
})();
